/* eslint-disable etc/no-commented-out-code */
import { logger as LOG } from '@sweetgreen/garnish';

const nativeName = 'TagManager RN';
const webName = 'TagManager WEB';
const webLibName = 'TagManager Web Lib';
const mockName = 'TagManager Mock';

export const nativeLogger = LOG.extend(nativeName);
export const webLogger = LOG.extend(webName);
export const webLibLogger = LOG.extend(webLibName);
export const mockLogger = LOG.extend(mockName);

// LOG.enable(nativeName);
// LOG.enable(webName);
// LOG.enable(webLibName);
// LOG.enable(mockName);
